import React,{Fragment}from 'react';

const About = () => {
  
  return <Fragment>
      <h1>About This App</h1>
      <p>Github Finder is a third party application using github api. This app useful for find github users.</p>
      <p>Version : 1.0.0</p>
      <p>&copy; Hardik Rana </p>
  </Fragment>;
};

export default About;